import { Fab } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';

function FloatingWhatApp() {
  return (
    <Fab
      sx={{
        backgroundColor: '#25D366',
        color: 'white',
        '&:hover': {
          backgroundColor: '#075E54',
        },
      }}
      aria-label="whatsapp"
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: 1000,
      }}
      onClick={() => window.open("https://wa.me/552127052276", "_blank")}
    >
      <WhatsApp />
    </Fab>
  );
}

export default FloatingWhatApp;